<span class="audience-pill" [class.on-image]="onImage">
    <span class="material-symbols-outlined" aria-hidden="true">{{ icon }}</span>
    <span>{{ label }}</span>
</span>
